import { Table } from "@shared/antd/table";
import { Modal } from "@shared/antd/modal";
import React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { columnsTable, IParticipant, scrollTable } from "./";
import Button, { ButtonType } from "../../../components/Button/Button";
import { debounce } from "app/shared/lodash/lodash";
import { checkParticipantsInclude, getCount, getUser, getUserWithSignal } from "../api/getParticipants";
import SearchInput from "../../../components/SearchInput";
import { observer } from "mobx-react";

type State = {
  filteredData: IParticipant[];
  searchField: string;
  pagination: {
    current: number;
    pageSize: number;
    total: number;
    onChange: (page: number) => void;
  };
  loading: boolean;
  abortController: AbortController;
}

type Props = {
  status: boolean;
  selectParticipant: (item: IParticipant) => void;
  selectedParticipants: IParticipant[];
  lang: string;
  modal: {
    visible: boolean;
    handleCancel: () => void;
  };
}

@observer
class AllParticipantsTable extends React.Component<WrappedComponentProps & Props, State> {
  constructor(props: WrappedComponentProps & Props) {
    super(props);

    this.state = {
      filteredData: [],
      searchField: "",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (page) => {
          this.handlePageChange(page);
        },
      },
      loading: false,
      abortController: new AbortController(),
    };
  }

  handlePageChange = (page: number) => {
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        current: page,
      },
      loading: true,
    }));
    const users = async () => {
      const res = await getUser({ searchValue: this.state.searchField, page, lang: this.props.lang });
      this.setState({ filteredData: res });
      this.setState({
        loading: false,
      });
    };
    users();
  };

  render() {
    const { filteredData, loading } = this.state;
    const { handleCancel, visible } = this.props.modal;
    const { selectedParticipants, status } = this.props;
    const checkTableInfo = () => {
      if (filteredData.length && filteredData) return filteredData;
      return null;
    };

    const withi18n = (id: string) => {
      return this.props.intl.formatMessage({ id: id });
    };

    const checkSelectedParticipant = (item?: IParticipant): boolean => {
      if (!item) return true;
      const res = checkParticipantsInclude(selectedParticipants, item);
      return !status && !res;
    };

    const search = async (searchValue: string) => {
      const { abortController } = this.state;
      searchValue = searchValue.replace(/\s+/g, " ");
      this.setState({ searchField: searchValue, loading: true });
      abortController.abort();
      this.setState({ abortController: new AbortController() });
      try {
        const signal = this.state.abortController.signal;
        const res = await getUserWithSignal({ searchValue, signal, lang: this.props.lang });
        const count = await getCount({ searchValue });
        this.setState({ filteredData: [] });
        this.setState((prevState) => ({
          pagination: {
            ...prevState.pagination,
            total: count,
          },
        }));
        this.setState({ filteredData: res });
      } finally {
        this.setState({
          loading: false,
        });
      }
    };
    const debouncedSearch = debounce(search, 800);

    return (
      <Modal
        title={withi18n("concourseParticipants")}
        visible={visible}
        onCancel={handleCancel}
        width={"80%"}
        footer={[
          <Button key="cancel" buttonType={ButtonType.PRIMARY} onClick={handleCancel}>
            {withi18n("keyPosition.modalTable.cancel")}
          </Button>,
        ]}
      >
        <SearchInput onSearch={debouncedSearch} />
        <Table dataSource={checkTableInfo()}
               size="default"
               loading={loading}
               bordered={false}
               scroll={scrollTable}
               pagination={this.state.pagination}
               rowKey={record => record.position_group_id + "select" + Math.random()}
        >
          {
            columnsTable.map((item) => (
              <Table.Column
                title={withi18n(item.title)}
                dataIndex={item.dataIndex}
                key={item.key}
                sorter={item.sorter}

                render={(text, record) => (
                  item.title !== "dismissalRequest.staffUnitPosition"
                    ? text
                    : <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>{text}</span>
                      <Button
                        style={{ margin: "12px" }}
                        disabled={checkSelectedParticipant(record)}
                        buttonType={ButtonType.PRIMARY}
                        onClick={() => this.props.selectParticipant(record)}
                      >
                        {withi18n("cubaReact.dataTable.listEditor.addItem")}
                      </Button>
                    </div>
                )}
              />
            ))
          }
        </Table>
      </Modal>
    );
  }
}

export const AllParticipantsTableComponent = injectIntl(AllParticipantsTable);


